import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import About from './components/About/About';
import Gallery from './components/Gallery/Gallery';
import Stats from './components/Stats/Stats';
import Contact from './components/Contact/Contact';

import './styles/global.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Stats />
      <Contact />
    </div>
  );
}

export default App;